export default __webpack_public_path__ + "static/media/Time Table.cbabe61b.svg";